import { useRef } from "react";
import { Card, Button, Segmented, Space } from "antd";
import RadarEngagementChart from "./engagement.radar.chart";
import { exportChartAsPDF } from "../../../utils/export.utils";

const ExportableRadarChartPanel = ({ data, dateRange }) => {
  const chartRef = useRef();

  return (
    <RadarEngagementChart
      radarData={data}
      ref={chartRef}
      filters={{ dateRange }}
    />
  );
};

export default ExportableRadarChartPanel;
